import React from 'react';

import {Banner, Button, Icon, Text} from '@albert-io/atomic';

import OnboardingPageLayout from '../OnboardingPageLayout';

export type ConsentOption = 'enroll-code' | 'class-invite' | 'parental-consent';

interface ConsentOptionStepProps {
  onSelectOption: (option: ConsentOption) => void;
  /** Non-empty when the student has already submitted a parental-consent email. */
  pendingParentEmail?: string;
  /** Manually re-checks whether the parent has approved (refetches the user query). */
  onCheckStatus?: () => void;
}

export default function ConsentOptionStep({
  onSelectOption,
  pendingParentEmail,
  onCheckStatus
}: ConsentOptionStepProps) {
  return (
    <OnboardingPageLayout>
      <Text className='text-xxl font-black'>Select an option</Text>

      <div className='flex flex-col gap-x1-half'>
        {pendingParentEmail && (
          <Banner type='info'>
            <div className='flex flex-1 flex-col gap-x0-half'>
              <Text size='s' color='inherit'>
                We&apos;ve sent an email to <strong>{pendingParentEmail}</strong>. Once your parent
                approves, you&apos;ll be able to continue.
              </Text>
            </div>
            {onCheckStatus && (
              <Button color='primary' variant='text' size='s' onClick={onCheckStatus}>
                <Text color='inherit' size='s'>
                  Check Status
                </Text>
              </Button>
            )}
          </Banner>
        )}
        <Button
          color='primary'
          variant='outlined'
          size='l'
          roundness='pill'
          className='w-full justify-between'
          onClick={() => onSelectOption('enroll-code')}
        >
          <Text color='inherit'>Enter a class code</Text>
          <Icon icon='arrow-right' />
        </Button>
        <Button
          color='primary'
          variant='outlined'
          size='l'
          roundness='pill'
          className='w-full justify-between'
          onClick={() => onSelectOption('class-invite')}
        >
          <Text color='inherit'>Accept class invitations</Text>
          <Icon icon='arrow-right' />
        </Button>
        <Button
          color='primary'
          variant='outlined'
          size='l'
          roundness='pill'
          className='w-full justify-between'
          onClick={() => onSelectOption('parental-consent')}
        >
          <Text color='inherit'>Request parental permission</Text>
          <Icon icon='arrow-right' />
        </Button>
      </div>
    </OnboardingPageLayout>
  );
}
